import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Forward to the production error reporter so we see render crashes
    // in /owner-admin/client-errors alongside async failures.
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      if (API_URL && error) {
        const wsId = (() => { try { return window.localStorage.getItem('currentWorkspaceId') || ''; } catch { return ''; } })();
        fetch(`${API_URL}/api/client-errors`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: String(error?.message || error).slice(0, 2000),
            stack: String(error?.stack || '').slice(0, 8000),
            url: window.location.href.slice(0, 500),
            user_agent: navigator.userAgent.slice(0, 500),
            workspace_id: wsId,
            kind: 'react_error_boundary',
            client_ts: new Date().toISOString(),
          }),
          keepalive: true,
          credentials: 'omit',
        }).catch(() => {});
      }
    } catch { /* never let the reporter crash the boundary */ }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', maxWidth: '600px', margin: '80px auto', fontFamily: '-apple-system, sans-serif' }}>
          <h2 style={{ color: '#dc2626', marginBottom: '16px' }}>Something went wrong</h2>
          <p style={{ color: '#6b7280', marginBottom: '16px' }}>
            Please try refreshing the page. If the issue persists, contact support.
          </p>
          <details style={{ background: '#f3f4f6', padding: '12px', borderRadius: '8px', fontSize: '13px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>Error Details</summary>
            <pre style={{ marginTop: '8px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#991b1b' }}>
              {this.state.error?.toString()}
            </pre>
            <pre style={{ marginTop: '4px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#6b7280', fontSize: '11px' }}>
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: '16px', padding: '8px 20px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
